export default __webpack_public_path__ + "static/feature1-a36d8985a86a8439ddd32dd2ecec930a.png";